import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Campaign from '@/views/Campaign.vue';
//import Home from './views/Home.vue';
import Register from '@/views/Register/Register.vue';
import Detail from './views/Detail.vue';
import ErrorPage from "./views/Errorpage.vue";
import Maintenance from './module/Maintenance/page/Maintenance.vue'

import LineLogin from "./module/LineLogin/page/LineLogin.vue";

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Campaign
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
        },
        {
            path: '/campaign',
            name: 'campaign',
            component: Campaign,
        },
        {
            path: '/detail/:campaignId',
            name: 'detail',
            component: Detail,
        },
        {
            path: '/detail/:campaignId/:redeemKey',
            name: 'detail',
            component: Detail,
        },
        {
            path: '/errorPage',
            name: 'errorpage',
            component: ErrorPage,
        },
        {
            path: '/linelogin',
            name: 'lineLogin',
            component: LineLogin,
        },
        {
            path: '/maintenance',
            name: 'maintenance',
            component: Maintenance,
        },

    ]
})
